import { render } from "./InformesTablaResultado.vue?vue&type=template&id=14469291"
import script from "./InformesTablaResultado.vue?vue&type=script&lang=js"
export * from "./InformesTablaResultado.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__